import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7db07f47"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-detail-extended-container" }
const _hoisted_2 = {
  class: "content-wrapper",
  ref: "scrollContainer"
}
const _hoisted_3 = { class: "row-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "운행지역", -1 /* HOISTED */))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow" }, " → ", -1 /* HOISTED */))
const _hoisted_7 = { class: "row-wrapper" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "운행시각", -1 /* HOISTED */))
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "departure-times-wrapper"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "chip" }, "기점", -1 /* HOISTED */))
const _hoisted_13 = { class: "times" }
const _hoisted_14 = {
  key: 0,
  class: "row-wrapper"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "시간표", -1 /* HOISTED */))
const _hoisted_16 = { class: "content" }
const _hoisted_17 = { class: "warning-text" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "기점 기준 출발 시각입니다.", -1 /* HOISTED */))
const _hoisted_19 = { class: "row-wrapper" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "정류장", -1 /* HOISTED */))
const _hoisted_21 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], {
      title: $setup.title,
      shouldHideBackButton: true,
      onOnClickClose: $setup.emitOnClickClose
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString($setup.firstBusStop.name) + "(기점)", 1 /* TEXT */),
          _hoisted_6,
          _createElementVNode("span", null, _toDisplayString($setup.lastBusStop.name) + "(종점)", 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("p", _hoisted_9, [
          ($props.isInsideShuttle)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString($setup.availableTimeStr), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString($setup.departureTimesStr), 1 /* TEXT */)
              ]))
        ])
      ]),
      ($props.isInsideShuttle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", _hoisted_17, [
                _createVNode($setup["InlineSvg"], {
                  class: "info-icon",
                  src: require('@/assets/icons/info.svg'),
                  alt: ""
                }, null, 8 /* PROPS */, ["src"]),
                _hoisted_18
              ]),
              _createVNode($setup["TimeTable"], {
                turns: $props.lineInfo.turns,
                nextBusStopChangeDateTime: $props.nextBusStopChangeDateTime
              }, null, 8 /* PROPS */, ["turns", "nextBusStopChangeDateTime"])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("p", _hoisted_21, [
          _createElementVNode("span", null, _toDisplayString($setup.busStopNames), 1 /* TEXT */)
        ])
      ]),
      ($setup.scrollContainer)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 1,
            container: $setup.scrollContainer
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true)
    ], 512 /* NEED_PATCH */)
  ]))
}